import * as React from 'react'
import useResizeObserver from "use-resize-observer"

interface IProps {
	children: (props: { width: number; height: number }) => React.ReactNode;
}

const DocumentWrapper = (props) => {
	const { children } = props
	const { ref, width, height } = useResizeObserver();

	return (
		<div ref={ref} className='document-wrapper'>
			{children({ width: width, height: height })}
		</div>
	)
}

export default DocumentWrapper